module.exports = __webpack_public_path__ + "cement/img/蒙版组 58@2x.b0f77d23.png";